import moment from 'moment';
import { React, fetchApi, PT } from '@gasbuddy/react';
import { Button, Modal, Header, Icon, Dimmer, Loader, Statistic, Grid } from 'semantic-ui-react';
import BigNumber from 'bignumber.js';
import {
  VictoryChart, VictoryArea, VictoryStack, VictoryTheme,
  VictoryTooltip, VictoryLegend, VictoryAxis,
} from 'victory';

import Style from './style.css';

export class StatsModal extends React.Component {
  state = {};

  onChange = (f, v) => { this.setState({ [f]: v }); }

  getStats = (e) => {
    e.preventDefault();
    const { offer: { offer_id: offerId } } = this.props;
    this.setState({ opened: true, loading: true }, async () => {
      const { body: stats } = await fetchApi({
        url: `/loyalty/offers/${offerId}/stats`,
        body: {},
      });
      let views = 0;
      let follows = 0;
      if (stats.impressionsByPosition) {
        stats.impressionsByPosition.forEach((s) => {
          s.conversion = s.followed / (s.views || 1);
          s.viewOnly = s.views - s.followed;
          views += s.views;
          follows += s.followed;
        });
      }
      if (stats.impressionsByDay) {
        stats.impressionsByDay.forEach((s) => {
          s.day = moment(s.day.replace('T00:00:00.000Z', '')).toDate();
          s.conversion = s.followed / (s.views || 1);
          s.viewOnly = s.views - s.followed;
        });
      }
      stats.conversion = new BigNumber(follows).times(100).dividedBy(views || 1).toFormat(2);
      this.setState({ stats, loading: false });
    });
  }

  render() {
    const { loading, opened, stats } = this.state;
    return (
      <Modal
        size="fullscreen"
        open={opened}
        closeIcon
        onClose={() => this.setState({ opened: false })}
        trigger={(
          <Button
            size="small"
            icon="chart line"
            onClick={this.getStats}
            color="green"
          />
        )}
      >
        <Header content="Offer Performance" />
        <Modal.Content scrolling>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            {stats && (
              <Grid columns="equal">
                <Grid.Row>
                  <Grid.Column style={{ height: 400 }}>
                    <VictoryChart animate width={400} height={400} theme={VictoryTheme.material}>
                      <VictoryStack>
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.impressionsByPosition} x="original_offer_position" y="followed" />
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.impressionsByPosition} x="original_offer_position" y="viewOnly" />
                      </VictoryStack>
                      <VictoryLegend
                        x={275}
                        y={80}
                        style={{ border: { stroke: 'black' } }}
                        title="Clicks by Position"
                        centerTitle
                        data={[{ name: 'To Partner' }, { name: 'Views' }]}
                      />
                    </VictoryChart>
                  </Grid.Column>
                  <Grid.Column style={{ height: 400 }}>
                    <VictoryChart animate width={400} height={400} theme={VictoryTheme.material} scale={{ x: 'time' }}>
                      <VictoryAxis tickFormat={x => moment(x).format('MM/DD')} />
                      <VictoryStack>
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.impressionsByDay} x="day" y="followed" />
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.impressionsByDay} x="day" y="viewOnly" />
                      </VictoryStack>
                      <VictoryLegend
                        x={275}
                        y={80}
                        style={{ border: { stroke: 'black' } }}
                        title="Clicks by Day"
                        centerTitle
                        data={[{ name: 'To Partner' }, { name: 'Views' }]}
                      />
                    </VictoryChart>
                  </Grid.Column>
                  <Grid.Column style={{ height: 400 }}>
                    <VictoryChart animate width={400} height={400} theme={VictoryTheme.material} scale={{ x: 'time' }}>
                      <VictoryAxis tickFormat={x => moment(x).format('MM/DD')} />
                      <VictoryStack>
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.rewardAging} x="week" y="created" />
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.rewardAging} x="week" y="declined" />
                        <VictoryArea labelComponent={<VictoryTooltip />} data={stats.rewardAging} x="week" y="settled" />
                      </VictoryStack>
                      <VictoryLegend
                        x={275}
                        y={80}
                        style={{ border: { stroke: 'black' } }}
                        title="Reward Aging"
                        centerTitle
                        data={[{ name: 'Pending' }, { name: 'Declined' }, { name: 'Settled' }]}
                      />
                    </VictoryChart>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column colSpan="3" textAlign="center">
                    <Statistic className={Style.stat}>
                      <Statistic.Value>{`${stats.conversion}%`}</Statistic.Value>
                      <Statistic.Label>Click Through</Statistic.Label>
                    </Statistic>
                    <Statistic className={Style.stat}>
                      <Statistic.Value>{`$${new BigNumber(stats.transactions.awarded).toFixed(2)}`}</Statistic.Value>
                      <Statistic.Label>GasBack Given</Statistic.Label>
                    </Statistic>
                    <Statistic className={Style.stat}>
                      <Statistic.Value>{stats.transactions.transactions}</Statistic.Value>
                      <Statistic.Label>Transactions</Statistic.Label>
                    </Statistic>
                    <Statistic className={Style.stat}>
                      <Statistic.Value>{stats.transactions.accounts}</Statistic.Value>
                      <Statistic.Label>Accounts</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={this.getStats}>
            <Icon name="refresh" />
            {' '}
            Refresh
          </Button>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

StatsModal.propTypes = {
  offer: PT.shape({ offerId: PT.number }).isRequired,
};
